import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { SmallBodyHighlight } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";

import styles from "../../../style.module.scss";

/**
 * Empty state for charts
 */
export const EmptyStateChart = () => {
    const [t] = useTranslation();

    return (
        <div className={styles["empty-state-chart"]}>
            <div>
                <div className={styles["empty-state-chart-text"]}>
                    <BarChartOutlinedIcon />
                    <SmallBodyHighlight color="grey">{t("Analytics.NoDataFound")}</SmallBodyHighlight>
                </div>
            </div>
        </div>
    );
};
